import {
  EMPTY_LIST,
  EMPTY_OBJECT,
  EMPTY_STRING,
} from '../../../constants/common'
import { getPhoneDisplayValue } from '../../Phone'

import { ProfileInfoFieldType } from './ProfileInfoWidget.constants'
import {
  formatInfoDate,
  formatInfoMoney,
  getInfoSelectLabel,
} from './ProfileInfoWidget.utils'

function getInfoFieldReadValue({ optionLabelKey, rawValue, type }) {
  switch (type) {
    case ProfileInfoFieldType.SELECT:
      return getInfoSelectLabel({ optionLabelKey, value: rawValue })
    case ProfileInfoFieldType.CURRENCY:
      return formatInfoMoney(rawValue)
    case ProfileInfoFieldType.DATE:
      return formatInfoDate(rawValue)
    case ProfileInfoFieldType.PHONE:
      return getPhoneDisplayValue(rawValue)
    default:
      return rawValue
  }
}

function isInfoWidgetCollapsibleField({ data, field }) {
  return !getInfoFieldReadValue({
    optionLabelKey: field.optionLabelKey,
    rawValue: data?.[field.name],
    type: field.type,
  })
}

export function hasInfoWidgetCollapsibleFields({ config = EMPTY_LIST, data }) {
  return config.some(field => isInfoWidgetCollapsibleField({ data, field }))
}

export function getInfoWidgetReadFields({
  config = EMPTY_LIST,
  data,
  fieldVariables = EMPTY_OBJECT,
  t,
}) {
  return config.map(field => {
    const { labelKey, name, optionLabelKey, placeholderKey, type } = field

    return {
      fieldVariables: fieldVariables[name] ?? EMPTY_LIST,
      isCollapsible: isInfoWidgetCollapsibleField({ data, field }),
      label: t(labelKey),
      name,
      placeholder: placeholderKey ? t(placeholderKey) : EMPTY_STRING,
      type,
      value: getInfoFieldReadValue({
        optionLabelKey,
        rawValue: data?.[name],
        type,
      }),
    }
  })
}
